export { default } from './Root'



// WEBPACK FOOTER //
// ./src/views/index.tsx